{
  "unknown_state": "สถานะอื่น",
  "financial": {
    "pending_payment": "รอชำระเงิน",
    "partially_paid": "ชำระบางส่วน",
    "paid": "ชำระแล้ว",
    "partially_refunded": "คืนเงินบางส่วน",
    "refunded": "คืนเงินแล้ว",
    "cancelled": "ยกเลิกแล้ว"
  },
  "fulfillment": {
    "unfulfilled": "ยังไม่ได้เตรียม",
    "preparing": "กำลังเตรียม",
    "ready": "แพ็กแล้ว รอส่ง",
    "shipped": "ส่งแล้ว",
    "in_transit": "กำลังขนส่ง",
    "delivered": "ถึงลูกค้าแล้ว",
    "partial": "ส่งไปบางส่วน",
    "pickup_ready": "พร้อมให้มารับ",
    "picked_up": "ลูกค้ารับแล้ว",
    "return_requested": "ลูกค้าขอคืน",
    "return_received": "ได้รับของคืนแล้ว"
  },
  "parcel": {
    "pending": "ยังไม่ส่ง",
    "preparing": "กำลังเตรียม",
    "ready": "แพ็กแล้ว",
    "shipped": "ส่งแล้ว",
    "in_transit": "กำลังขนส่ง",
    "delivered": "ถึงแล้ว",
    "pickup_ready": "พร้อมให้มารับ",
    "picked_up": "ลูกค้ารับแล้ว",
    "cancelled": "ยกเลิกแล้ว"
  },
  "review": {
    "none": "ไม่ต้องตรวจ",
    "pending_review": "รอผู้จัดการตรวจ",
    "approved": "ตรวจแล้ว ผ่าน",
    "rejected": "ไม่ผ่าน"
  },
  "tax": {
    "domestic_taxable": "ภาษี 10% (ในญี่ปุ่น)",
    "export_exempt": "ส่งออก 0%",
    "tax_free_tourist": "ปลอดภาษี (免税)",
    "non_taxable": "ไม่มีภาษีบริโภค"
  },
  "evidence": {
    "not_required": "ไม่ต้องมีหลักฐานส่งออก",
    "missing": "ยังไม่มีหลักฐานส่งออก",
    "complete": "เก็บหลักฐานส่งออกแล้ว",
    "after_shipping": "เก็บหลักฐานส่งออกหลังส่งของ"
  },
  "channel": {
    "web": "เว็บ",
    "pos": "หน้าร้าน",
    "ebay": "eBay",
    "whatnot": "Whatnot",
    "mercari": "Mercari",
    "other": "อื่นๆ"
  },
  "delivery": {
    "ship": "ส่งทางไปรษณีย์/ขนส่ง",
    "pickup": "รับที่ร้าน"
  },
  "customer_kind": {
    "guest": "ไม่ได้สมัครสมาชิก",
    "registered": "สมาชิก"
  },
  "views": {
    "awaiting_bank_transfer": "รอชำระ (โอนเงิน)",
    "to_prepare": "รอเตรียม",
    "ready_to_ship": "รอส่ง",
    "pickup_ready": "รับที่ร้าน",
    "export_missing_evidence": "ต่างประเทศ รอเอกสาร",
    "returns": "คืนสินค้า/คืนเงิน",
    "flagged": "ต้องตรวจ",
    "to_ship": "จ่ายแล้ว ยังไม่ส่ง"
  },
  "columns": {
    "number": "ออเดอร์",
    "customer": "ลูกค้า",
    "total": "ยอดรวม",
    "tax": "ภาษี",
    "payment": "การชำระ",
    "fulfillment": "สินค้า",
    "placed": "สั่งเมื่อ",
    "risk": "ปัญหา",
    "actions": "ทำอะไร"
  },
  "filters": {
    "q": "ค้นหา",
    "q_placeholder": "เลขออเดอร์ ชื่อ อีเมล เลขพัสดุ รหัสสินค้า",
    "channel": "ขายที่ไหน",
    "delivery": "วิธีรับของ",
    "country": "ประเทศ",
    "evidence": "หลักฐานส่งออก",
    "customer_kind": "สมาชิกหรือไม่"
  },
  "list": {
    "intro": "ออเดอร์เว็บและหน้าร้านในที่เดียว แตะออเดอร์เพื่อทำขั้นต่อไป",
    "create": "สร้างออเดอร์ (แชท/LINE)",
    "new": "ใหม่",
    "bulk_ready": "ทำเครื่องหมายแพ็กแล้ว ({{count}})",
    "bulk_ready_title": "ทำเครื่องหมาย {{count}} ออเดอร์ว่าแพ็กแล้ว?",
    "bulk_ready_consequence": "เปลี่ยนเฉพาะออเดอร์ที่กำลังเตรียม ลูกค้าแต่ละคนจะได้อีเมล \"เตรียมของแล้ว\"",
    "bulk_ready_done_other": "แพ็กแล้ว {{count}} ออเดอร์",
    "bulk_ready_partly": "แพ็กแล้ว {{ok}} ออเดอร์ เปลี่ยนไม่ได้ {{failed}} — เปิดดูเหตุผล",
    "bulk_ship": "ส่งของ ({{count}})",
    "print_slips": "พิมพ์ใบแพ็กของ",
    "print_invoices": "พิมพ์ใบกำกับสินค้าส่งออก",
    "print_packing_slip_other": "กำลังทำใบแพ็กของ {{count}} ออเดอร์",
    "print_commercial_invoice_other": "กำลังทำใบกำกับสินค้าส่งออก {{count}} ออเดอร์",
    "print_hint": "จะอยู่ในปุ่ม \"พิมพ์\" ของแต่ละออเดอร์ในไม่กี่วินาที",
    "print_none": "ออเดอร์ที่เลือกไม่มีส่งต่างประเทศ",
    "print_partly": "ทำได้ {{ok}} ทำไม่ได้ {{failed}}"
  },
  "steps": {
    "title": "ขั้นต่อไป",
    "title_pickup": "ขั้นต่อไป (รับที่ร้าน)",
    "nothing_left": "ออเดอร์นี้ไม่มีอะไรต้องทำแล้ว",
    "label": {
      "confirm_payment": "入金確認 เงินเข้าแล้ว",
      "start_preparing": "準備開始 เริ่มเตรียม",
      "mark_ready": "準備完了 แพ็กแล้ว",
      "ship": "発送 ส่งของ",
      "mark_delivered": "お届け済み ถึงแล้ว",
      "pickup_ready": "店頭受取可 พร้อมให้มารับ",
      "hand_over": "受け渡し済み ส่งมอบแล้ว"
    },
    "state": {
      "done": "เสร็จแล้ว",
      "now": "ทำขั้นนี้ตอนนี้",
      "later": "ยังไม่ถึง",
      "blocked": "ตอนนี้ทำไม่ได้"
    },
    "why": {
      "done": "ทำไปแล้ว",
      "needs_previous": "ต้องทำขั้นก่อนหน้า",
      "not_paid": "ยังไม่ได้รับเงิน",
      "under_review": "ต้องให้ผู้จัดการตรวจออเดอร์นี้ก่อน",
      "cancelled": "ออเดอร์นี้ยกเลิกแล้ว",
      "paid_elsewhere": "ไม่ใช่การโอนเงิน — ไม่มีอะไรต้องยืนยันที่นี่",
      "service_says_no": "ออเดอร์นี้ทำขั้นนี้ไม่ได้ตอนนี้"
    },
    "done": {
      "start_preparing": "{{number}}: กำลังเตรียม",
      "mark_ready": "{{number}}: แพ็กแล้ว",
      "pickup_ready": "{{number}}: พร้อมให้มารับ",
      "mark_delivered": "{{number}}: ถึงลูกค้าแล้ว",
      "hand_over": "{{number}}: ส่งมอบแล้ว"
    },
    "done_hint": {
      "start_preparing": "ลูกค้าเห็น \"กำลังเตรียม\" ในหน้าออเดอร์",
      "mark_ready": "ลูกค้าจะได้อีเมล \"เตรียมของแล้ว\"",
      "pickup_ready": "ลูกค้าจะได้อีเมล \"มารับได้แล้ว\"",
      "mark_delivered": "ลูกค้าเห็น \"ถึงแล้ว\"",
      "hand_over": "ออเดอร์นี้เสร็จแล้ว"
    },
    "confirm": {
      "mark_delivered": {
        "title": "ทำเครื่องหมายว่าถึงลูกค้าแล้วทั้งหมด?",
        "body": "ใช้เมื่อขนส่งหรือลูกค้าบอกว่าได้รับแล้ว ย้อนกลับไม่ได้"
      },
      "hand_over": {
        "title": "ลูกค้ารับของไปแล้วใช่ไหม?",
        "body": "ตรวจเลขออเดอร์ในมือถือของลูกค้าก่อน ย้อนกลับไม่ได้"
      }
    }
  },
  "detail": {
    "back": "ออเดอร์ทั้งหมด",
    "load_failed": "เปิดออเดอร์ไม่ได้",
    "placed": "สั่งเมื่อ",
    "print": "พิมพ์",
    "contact": "อีเมลถึงลูกค้า",
    "mail_subject": "เรื่องออเดอร์ {{number}} ของคุณ",
    "cancel": "ยกเลิกออเดอร์",
    "consignment_scope": "คุณเห็นเฉพาะการ์ดฝากขายของออเดอร์นี้",
    "export_proof": "ต้องเก็บหลักฐานส่งออก",
    "export_proof_body": "พัสดุนี้ส่งต่างประเทศโดยไม่มีภาษีบริโภค — เก็บใบรับฝากของไปรษณีย์หรือใบอนุญาตส่งออก",
    "export_proof_open": "เพิ่มหลักฐาน",
    "refund": "คืนเงิน",
    "edit_address": "แก้ไข",
    "cancelled_refund_pending": "ยกเลิกแล้ว — กำลังคืนเงิน"
  },
  "lines": {
    "title_other": "{{count}} รายการ",
    "sealed": "ซีล",
    "consigned": "ของฝากขาย (委託品)",
    "consigned_note": "ในใบเสร็จแสดงเป็น 委託品／インボイス対象外 — ร้านได้เฉพาะค่าคอมมิชชัน",
    "qty_other": "{{count}} ชิ้น",
    "sent": "ส่งแล้ว {{count}} จาก {{of}}",
    "refunded": "คืนเงิน {{count}}",
    "each": "ชิ้นละ",
    "discount": "ส่วนลด",
    "stock_now": "ตอนนี้:",
    "stock_history": "ประวัติสต็อก",
    "unit_states": {
      "pending": "กำลังจองการ์ด",
      "released": "ปล่อยการ์ดจากออเดอร์แล้ว"
    }
  },
  "totals": {
    "title": "ยอดเงิน",
    "subtotal": "สินค้า",
    "discount": "ส่วนลด",
    "shipping": "ค่าส่ง",
    "duties": "ภาษีนำเข้าที่จ่ายล่วงหน้า",
    "total": "ยอดรวม (รวมภาษี)",
    "tax_included": "ภาษีบริโภคที่รวมอยู่",
    "received": "ได้รับแล้ว",
    "refunded": "คืนเงินแล้ว",
    "outstanding": "ยังค้างชำระ"
  },
  "payments": {
    "title": "การชำระเงิน",
    "unavailable": "ตอนนี้แสดงรายละเอียดการชำระไม่ได้ ส่วนอื่นของออเดอร์ยังใช้ได้",
    "none": "ยังไม่มีการชำระ",
    "amount": "จำนวน",
    "received": "เงินเข้า",
    "fee": "ค่าธรรมเนียมเครื่องรูดบัตร",
    "net": "ร้านได้รับ",
    "refunded": "คืนเงินแล้ว",
    "reference": "รหัสการชำระ",
    "due": "ชำระภายใน",
    "captured_at": "ชำระเมื่อ",
    "notice_title": "ลูกค้าแจ้งว่าโอนแล้ว (振込連絡)",
    "notice_line": "จาก {{name}}:",
    "refunds": "การคืนเงิน",
    "method": {
      "bank_transfer_manual": "โอนเงินผ่านธนาคาร (銀行振込)",
      "cash": "เงินสด",
      "edc_external": "เครื่องรูดบัตร",
      "pay_in_store": "จ่ายที่ร้าน",
      "store_credit": "เครดิตร้าน",
      "none": "ยังไม่ได้เลือก",
      "other": "วิธีอื่น"
    },
    "status": {
      "pending": "รอ",
      "requires_action": "รอลูกค้า",
      "processing": "กำลังตรวจ",
      "authorized": "อนุมัติแล้ว",
      "captured": "ได้รับเงินแล้ว",
      "failed": "ไม่สำเร็จ",
      "expired": "หมดเวลา",
      "partially_refunded": "คืนเงินบางส่วน",
      "refunded": "คืนเงินแล้ว"
    },
    "refund_status": {
      "requested": "ขอแล้ว",
      "pending_approval": "รออนุมัติ",
      "approved": "อนุมัติแล้ว",
      "processing": "กำลังคืน",
      "completed": "คืนแล้ว",
      "failed": "ไม่สำเร็จ",
      "rejected": "ไม่อนุมัติ"
    }
  },
  "address": {
    "title": "ส่งไปที่",
    "pickup_title": "รับที่ร้าน",
    "pickup_body": "ลูกค้ามารับที่ร้าน ตรวจเลขออเดอร์ในมือถือของลูกค้า",
    "none": "ไม่มีที่อยู่",
    "map": "เปิดแผนที่",
    "opens_new_tab": "(เปิดในแท็บใหม่)",
    "billing": "ที่อยู่ออกบิล",
    "shipping_method": "การส่งที่เลือก",
    "export_hint": "ส่งต่างประเทศโดยไม่มีภาษีบริโภค",
    "export_open": "หลักฐานส่งออก"
  },
  "timeline": {
    "title": "เกิดอะไรขึ้นบ้าง",
    "empty": "ยังไม่มี",
    "by": "โดย {{name}}",
    "customer_sees": "ลูกค้าเห็นด้วย",
    "other": "บันทึกการเปลี่ยนแปลง",
    "types": {
      "placed": "สั่งซื้อแล้ว",
      "paid": "ยืนยันเงินเข้า (入金確認)",
      "payment_notice_received": "ลูกค้าแจ้งว่าโอนแล้ว",
      "payment_short": "เงินเข้าน้อยกว่ายอด",
      "payment_over": "เงินเข้ามากกว่ายอด",
      "payment_due_extended": "ขยายเวลาชำระ",
      "variance_resolved": "จัดการเงินส่วนเกินแล้ว",
      "overpayment_refunded": "คืนเงินส่วนเกินแล้ว",
      "captured_after_cancel": "เงินเข้าหลังยกเลิก",
      "preparing": "เริ่มเตรียม (準備開始)",
      "ready": "แพ็กแล้ว (準備完了)",
      "shipped": "ส่งแล้ว (発送)",
      "in_transit": "กำลังขนส่ง",
      "delivered": "ถึงแล้ว (お届け済み)",
      "pickup_ready": "พร้อมให้มารับ",
      "picked_up": "ส่งมอบที่ร้านแล้ว",
      "pickup_recorded": "บันทึกการรับที่เครื่องแคชเชียร์",
      "tracking_corrected": "แก้เลขพัสดุแล้ว",
      "cancel_requested": "ลูกค้าขอยกเลิก",
      "cancelled": "ยกเลิกแล้ว",
      "refunded": "คืนเงินแล้ว",
      "return_requested": "ลูกค้าขอคืน",
      "return_received": "ได้รับของคืนแล้ว",
      "return_refund_requested": "ขอคืนเงินของที่คืน",
      "pos_return_recorded": "คืนของที่เครื่องแคชเชียร์",
      "pos_void_recorded": "ยกเลิกการขายที่เครื่องแคชเชียร์",
      "void": "ยกเลิกการชำระ",
      "hold_expired": "หมดเวลาจอง",
      "hold_lost": "เก็บการ์ดไว้ไม่ได้",
      "hold_reacquired": "เก็บการ์ดไว้อีกครั้ง",
      "hold_renewed": "ขยายเวลาจอง",
      "oversell_conflict": "การ์ดถูกขายซ้ำ",
      "note": "โน้ต",
      "customer_note": "ข้อความจากลูกค้า",
      "flag_set": "ทำเครื่องหมายว่ามีปัญหา",
      "flag_cleared": "ตรวจปัญหาแล้ว",
      "document_requested": "ขอเอกสาร",
      "document_issued": "ทำเอกสารแล้ว",
      "export_evidence_added": "เพิ่มหลักฐานส่งออก",
      "email_resent": "ส่งอีเมลอีกครั้ง",
      "edited": "แก้ไขออเดอร์"
    }
  },
  "actor": {
    "customer": "ลูกค้า",
    "pos": "เครื่องแคชเชียร์",
    "system": "ระบบ",
    "staff": "พนักงาน",
    "you": "คุณ"
  },
  "notes": {
    "title": "โน้ตสำหรับทีม",
    "label": "เพิ่มโน้ต",
    "placeholder": "เช่น ลูกค้าขอห่อของขวัญ",
    "hint": "เฉพาะพนักงานที่เห็นโน้ต",
    "add": "เพิ่มโน้ต",
    "saved": "เพิ่มโน้ตแล้ว",
    "tags": "แท็ก",
    "tag_placeholder": "เช่น ของขวัญ",
    "add_tag": "เพิ่มแท็ก",
    "remove_tag": "ลบแท็ก {{tag}}"
  },
  "flags": {
    "title": "ปัญหา",
    "under_review": "ออเดอร์นี้รอผู้จัดการตรวจ ห้ามส่งของก่อน",
    "tap_to_fix": "มีปัญหา — กดเพื่อดูวิธีแก้",
    "other": "มีเรื่องต้องตรวจ",
    "fraud_risk": "อาจเป็นการโกง",
    "address_mismatch": "ประเทศที่ออกบิลกับที่ส่งไม่ตรงกัน",
    "high_value": "ออเดอร์มูลค่าสูง",
    "manual_review": "พักไว้เพื่อตรวจ",
    "first_order_international": "ออเดอร์แรกจากต่างประเทศ",
    "overpaid": "ลูกค้าจ่ายเกิน",
    "underpaid": "ลูกค้าจ่ายไม่ครบ",
    "oversell_conflict": "การ์ดถูกขายซ้ำ",
    "fix": {
      "fraud_risk": "ตรวจข้อมูลลูกค้าและติดต่อถ้าจำเป็น ผู้จัดการตัดสินว่าจะไปต่อหรือไม่",
      "address_mismatch": "ให้ลูกค้ายืนยันที่อยู่ก่อนส่ง",
      "high_value": "ตรวจออเดอร์ แล้วผู้จัดการกดว่าตรวจแล้ว",
      "manual_review": "อ่านโน้ต แล้วผู้จัดการกดว่าตรวจแล้ว",
      "first_order_international": "ออเดอร์ไม่ได้ถูกหยุด ตรวจที่อยู่และข้อมูลศุลกากร",
      "overpaid": "คืนเงินส่วนเกินหรือให้เป็นเครดิตร้าน (ผู้จัดการ)",
      "underpaid": "ขอให้ลูกค้าโอนส่วนที่เหลือ หรือรับเท่าที่ได้",
      "oversell_conflict": "เปิดหน้าปัญหาเพื่อตัดสินว่าลูกค้าคนไหนได้การ์ด",
      "other": "ดูออเดอร์และโน้ต"
    },
    "open_conflicts": "เปิดหน้าปัญหา",
    "clear": "ตรวจแล้ว ไปต่อได้",
    "clear_title": "ทำเครื่องหมายว่าตรวจปัญหานี้แล้ว?",
    "clear_consequence": "ออเดอร์จะไปต่อได้ เขียนว่าตรวจอะไรไป",
    "cleared": "ตรวจปัญหาแล้ว",
    "hold": "พักออเดอร์นี้เพื่อตรวจ",
    "hold_title": "พักออเดอร์นี้?",
    "hold_consequence": "ส่งของไม่ได้จนกว่าผู้จัดการจะตรวจ เขียนเหตุผล",
    "held": "พักออเดอร์ไว้เพื่อตรวจแล้ว"
  },
  "cancel": {
    "title": "ยกเลิก {{number}}",
    "description": "ทำได้ก่อนส่งของเท่านั้น",
    "why": "ทำไม?",
    "reasons": {
      "customer_request": "ลูกค้าขอ",
      "payment_expired": "ไม่โอนเงิน",
      "out_of_stock": "ของมีปัญหา",
      "fraud_suspected": "น่าจะโกง",
      "duplicate": "สั่งซ้ำ",
      "other": "อื่นๆ"
    },
    "note": "เขียนสั้นๆ (เก็บในประวัติ)",
    "note_required": "\"อื่นๆ\" ต้องเขียนสั้นๆ",
    "restock": "คืนของเข้าสต็อกเพื่อขาย",
    "refund": "คืนเงิน",
    "consequence": "ลูกค้าจะได้อีเมล \"ยกเลิกแล้ว\"",
    "consequence_refund": "ลูกค้าจะได้อีเมล \"ยกเลิกแล้ว\" การคืนเงินเป็นการบันทึก — โอนเงินคืนเองที่ธนาคาร",
    "confirm": "ยกเลิกออเดอร์",
    "done": "ยกเลิก {{number}} แล้ว",
    "done_hint": "ของกลับไปขายแล้ว",
    "done_refund_hint": "อย่าลืมโอนเงินคืนที่ธนาคาร",
    "write_off": "สินค้าเป็นอย่างไร?",
    "write_offs": {
      "damaged": "เสียหาย — ขายไม่ได้",
      "lost": "หาย — หาไม่เจอ"
    },
    "done_refund_approval": "ต้องคืน ¥{{amount}} — ผู้จัดการต้องอนุมัติก่อน (ช่อง \"เงินที่ต้องคืน\")",
    "done_write_off": "ตัดสินค้าออกในประวัติสต็อกแล้ว",
    "done_stock_pending": "สินค้าจะกลับมาขายในอีกสักครู่"
  },
  "queue": {
    "intro": "การโอนที่ต้องตรวจกับบัญชีธนาคาร รายการที่ลูกค้าแจ้งว่าโอนแล้วอยู่ข้างบน",
    "tabs": "การโอนที่แสดง",
    "tab_all": "รอยืนยัน",
    "tab_overdue": "เกินกำหนด",
    "to_pay": "ยอดที่ต้องโอน",
    "due": "กำหนดโอน",
    "no_due": "ไม่มีกำหนด",
    "overdue": "เกินกำหนด — การจองจะถูกปล่อย",
    "days_left": "เหลือ {{d}} วัน {{h}} ชม.",
    "hours_left": "เหลือ {{h}} ชม.",
    "notice": "ลูกค้าแจ้ง (振込連絡)",
    "no_notice": "ยังไม่แจ้ง",
    "has_slip": "มีสลิป",
    "remind": "ส่งอีเมลเตือน",
    "remind_aria": "ส่งข้อมูลการโอนอีกครั้งสำหรับ {{number}}",
    "reminded": "{{number}}: ส่งอีเมลข้อมูลการโอนอีกครั้งแล้ว",
    "cancel": "ไม่มีเงินเข้า → ยกเลิก",
    "cancel_aria": "ยกเลิก {{number}} (ไม่มีเงินเข้า)",
    "empty": "ไม่มีการโอนที่ต้องตรวจ",
    "empty_overdue": "ไม่มีการโอนที่เกินกำหนด"
  },
  "transfer": {
    "title": "入金確認 — เงินเข้าแล้ว",
    "description": "{{number}} · {{name}}",
    "expected": "ยอดที่ยังค้าง",
    "notice": "ลูกค้าแจ้งว่า {{name}} โอน {{amount}}",
    "amount": "ยอดที่เข้าจริง",
    "short": "น้อยกว่ายอด {{amount}} — จะทำอย่างไร?",
    "short_hold": "รอส่วนที่เหลือ (ออเดอร์ยังรอชำระ)",
    "short_capture_partial": "รับเท่าที่เข้า (ออเดอร์เป็นชำระบางส่วน)",
    "short_contact": "อีเมลถึงลูกค้าได้จากหน้าออเดอร์",
    "over": "มากกว่ายอด {{amount}} ออเดอร์จะเป็นชำระแล้ว จัดการส่วนเกินที่หน้าออเดอร์ (คืนเงินหรือเครดิตร้าน)",
    "received_at": "เงินเข้าเมื่อ (เวลาญี่ปุ่น)",
    "received_at_hint": "ตามรายการในบัญชี",
    "payer": "ชื่อผู้โอน",
    "reference": "อ้างอิงธนาคาร",
    "reference_hint": "ไม่บังคับ — บรรทัดในรายการบัญชี",
    "slip": "สลิปโอน (ไม่บังคับ)",
    "slip_from_customer": "มีสลิปของลูกค้าแนบแล้ว",
    "note": "โน้ต (ไม่บังคับ)",
    "confirm": "ยืนยันได้รับ {{amount}}",
    "confirm_hold": "บันทึก {{amount}} แล้วรอส่วนที่เหลือ",
    "confirm_plain": "ยืนยัน",
    "blocker": {
      "amount_invalid": "พิมพ์ยอดที่เข้าจริง (เยนเต็ม)",
      "choose_short": "เงินเข้าไม่ครบ — เลือกก่อนว่าจะทำอย่างไร"
    },
    "wait_upload": "รอให้อัปโหลดสลิปเสร็จก่อน",
    "no_payment": "ออเดอร์นี้ไม่มีการโอนที่รอยืนยัน",
    "load_failed": "โหลดออเดอร์ไม่ได้",
    "customer_mail": "ลูกค้าจะได้อีเมล 注文確定 และใบเสร็จ",
    "outcome": {
      "captured": "{{number}}: ชำระแล้ว",
      "captured_within_tolerance": "{{number}}: ชำระแล้ว (ส่วนต่างเล็กน้อยรับได้)",
      "captured_partial": "{{number}}: ชำระบางส่วน",
      "captured_overpaid": "{{number}}: ชำระแล้ว — เงินเข้าเกินยอด",
      "held_underpaid": "{{number}}: บันทึกแล้ว — รอส่วนที่เหลือ"
    }
  },
  "ship": {
    "title": "発送 — ส่ง {{number}}",
    "description": "ของที่เหลือทั้งหมดไปในพัสดุนี้",
    "partial_note": "ส่งเฉพาะชิ้นที่ติ๊ก ที่เหลือส่งทีหลังได้",
    "what": "ของในพัสดุ",
    "qty_of": "{{qty}} / {{of}}",
    "fewer": "ลด {{title}} ลง 1",
    "more": "เพิ่ม {{title}} 1",
    "carrier": "ขนส่ง",
    "other_carriers": "ขนส่งอื่น",
    "carriers_failed": "โหลดรายชื่อขนส่งไม่ได้ ลองอีกครั้ง",
    "tracking": "เลขพัสดุ (สแกนหรือพิมพ์)",
    "tracking_hint": "สแกนบาร์โค้ดบนใบส่งของ",
    "tracking_example": "หน้าตาแบบ {{example}}",
    "tracking_ok": "รูปแบบถูกต้อง",
    "tracking_unusual": "ไม่เหมือนเลขของขนส่งนี้ (เช่น {{example}}) ตรวจอีกครั้ง — ยังส่งได้",
    "test_link": "ทดสอบลิงก์ติดตาม",
    "no_tracking": "ไม่มีเลขพัสดุ",
    "no_tracking_title": "ส่งโดยไม่มีเลขพัสดุ?",
    "no_tracking_consequence": "ลูกค้าจะติดตามพัสดุไม่ได้ ใช้เฉพาะขนส่งที่ไม่มีการติดตาม",
    "no_tracking_confirm": "ส่งโดยไม่มีเลข",
    "no_tracking_set": "ส่งโดยไม่มีเลขพัสดุ",
    "add_tracking": "ใส่เลข",
    "from": "ส่งจาก",
    "when": "ส่งเมื่อ (เวลาญี่ปุ่น)",
    "when_hint": "ตอนนี้ ยกเว้นส่งไปก่อนหน้านี้",
    "zonos_id": "Zonos declaration ID",
    "zonos_hint": "พัสดุไปสหรัฐฯ $100–2,500 ทางไปรษณีย์ญี่ปุ่นต้องจ่ายภาษีนำเข้าล่วงหน้า (อยู่บนใบส่งของ)",
    "high_value": "มูลค่า ¥100,000 ขึ้นไป",
    "hv_photos": "ถ่ายรูปของและกล่องแล้ว",
    "hv_insurance": "ประกันเต็มมูลค่า",
    "hv_not_insurable": "ขนส่งนี้ไม่มีประกัน — เลือกขนส่งอื่น",
    "hv_signature": "ลายเซ็นตอนรับ",
    "override": "ผู้จัดการ: ส่งเลยเพราะ…",
    "override_hint": "เก็บในประวัติ",
    "confirm": "ส่งของ",
    "confirm_partial": "ส่งชิ้นเหล่านี้",
    "problem": {
      "no_lines": "ติ๊กอย่างน้อย 1 ชิ้น",
      "no_carrier": "เลือกขนส่ง",
      "no_tracking": "สแกนหรือพิมพ์เลขพัสดุ (หรือเลือก \"ไม่มีเลขพัสดุ\")",
      "high_value": "พัสดุ ¥100,000 ขึ้นไป ต้องติ๊กครบ 3 ข้อ"
    },
    "done": "ส่ง {{number}} แล้ว",
    "done_partial": "{{number}}: ส่งไปบางส่วนแล้ว",
    "done_hint": "ลูกค้าได้อีเมล + ลิงก์ติดตาม เลขผิดแก้ได้ภายใน 10 นาที",
    "done_hint_no_tracking": "ลูกค้าได้อีเมล \"ส่งแล้ว\""
  },
  "customs": {
    "title": "ศุลกากร (ดูอย่างเดียว)",
    "us_ddp": "สหรัฐฯ: ต้องเป็น DDP — พัสดุไปรษณีย์ญี่ปุ่น $100–2,500 ต้องจ่ายภาษีล่วงหน้าผ่าน Zonos",
    "loading": "กำลังโหลดข้อมูลศุลกากร…",
    "unavailable": "ตอนนี้แสดงข้อมูลศุลกากรไม่ได้",
    "incoterm": "ภาษีนำเข้า",
    "incoterms": {
      "DDP": "ร้านจ่าย (DDP)",
      "DDU": "ลูกค้าจ่าย (DDU)"
    },
    "form": "แบบฟอร์ม",
    "value": "มูลค่าที่แจ้ง",
    "weight": "น้ำหนัก",
    "grams": "{{g}} ก.",
    "duties_prepaid": "ภาษีที่จ่ายล่วงหน้า",
    "zonos": "Zonos",
    "zonos_missing": "ยังไม่ได้ใส่",
    "warning_other": "ตรวจข้อมูลศุลกากร",
    "print_invoice": "พิมพ์ใบกำกับสินค้าส่งออก",
    "print_cn": "พิมพ์ CN22 / CN23",
    "printing": "กำลังทำเอกสาร — จะอยู่ในปุ่ม \"พิมพ์\" ในไม่กี่วินาที"
  },
  "parcels": {
    "title_other": "พัสดุ {{count}} ชิ้น",
    "track": "ติดตาม",
    "no_tracking": "ไม่มีเลขพัสดุ",
    "shipped_at": "ส่งเมื่อ",
    "in_transit_at": "ขนส่งเมื่อ",
    "delivered_at": "ถึงเมื่อ",
    "pickup_ready_at": "พร้อมให้มารับเมื่อ",
    "picked_up_at": "รับไปเมื่อ",
    "mark_in_transit": "配送中 กำลังขนส่ง",
    "mark_delivered": "お届け済み ถึงแล้ว",
    "deliver_title": "ทำเครื่องหมายว่าพัสดุนี้ถึงแล้ว?",
    "deliver_consequence": "ลูกค้าเห็น \"ถึงแล้ว\" ย้อนกลับไม่ได้",
    "fix": "แก้เลข",
    "fix_title": "แก้เลขพัสดุ",
    "fix_description": "ลูกค้าได้ลิงก์ใหม่",
    "fix_save": "บันทึกเลข",
    "fixed": "แก้เลขพัสดุแล้ว",
    "customer_sees": "แสดงในหน้าออเดอร์ของลูกค้า",
    "done_in_transit": "พัสดุกำลังขนส่ง",
    "done_delivered": "พัสดุถึงแล้ว"
  },
  "pickups": {
    "intro": "ออเดอร์ที่ลูกค้ามารับที่ร้าน เทียบเลขออเดอร์ในมือถือลูกค้า แล้วส่งมอบ",
    "load_failed": "โหลดรายการรับที่ร้านไม่ได้",
    "waiting_other": "พร้อมแล้ว — รอลูกค้า ({{count}})",
    "none_waiting": "ไม่มีรายการที่รอลูกค้า",
    "to_prepare_other": "ต้องเตรียม ({{count}})",
    "none_to_prepare": "ไม่มีอะไรต้องเตรียม",
    "pay_at_counter": "จ่ายที่เคาน์เตอร์",
    "use_pos": "รับเงินที่เครื่องแคชเชียร์ — ส่งมอบบันทึกที่นั่น",
    "scan": {
      "title": "สแกน QR ของลูกค้า",
      "label": "QR หรือข้อความใต้ QR",
      "hint": "สแกน QR ในมือถือลูกค้า (เปิดได้จากอีเมล \"พร้อมรับที่ร้าน\") หรือพิมพ์ข้อความที่อยู่ใต้ QR",
      "find": "หาออเดอร์",
      "invalid": "QR นี้ไม่ใช่ออเดอร์รับที่ร้านของร้านเรา — ขอเลขออเดอร์จากลูกค้าแล้วเทียบกับรายการด้านล่าง",
      "too_short": "รหัสสั้นเกินไป — ลองสแกนอีกครั้ง",
      "not_ready": "ยังไม่พร้อมให้รับ — เตรียมของก่อน",
      "already": "ส่งมอบไปแล้ว",
      "cancelled": "ออเดอร์นี้ถูกยกเลิกแล้ว — ห้ามส่งมอบสินค้า",
      "confirm_body": "QR ตรงกับออเดอร์นี้ ส่งมอบของให้ลูกค้า — ย้อนกลับไม่ได้",
      "handed_over": "ส่งมอบ {{number}} แล้ว"
    }
  },
  "bulk_ship": {
    "title_other": "ส่ง {{count}} ออเดอร์",
    "intro": "เลือกขนส่งครั้งเดียว แล้วสแกนเลขพัสดุทีละออเดอร์ — Enter ไปออเดอร์ถัดไป",
    "tracking_for": "เลขพัสดุของ {{number}}",
    "skip": {
      "high_value": "มูลค่า ¥100,000 ขึ้นไป — ส่งจากหน้าออเดอร์",
      "not_ready": "ยังส่งไม่ได้"
    },
    "open": "เปิดออเดอร์",
    "row_done": "ส่งแล้ว — {{number}}",
    "sending": "กำลังส่ง",
    "running": "กำลังส่ง…",
    "confirm_other": "ส่ง {{count}} ออเดอร์",
    "done_other": "ส่งแล้ว {{count}} ออเดอร์",
    "partly": "ส่งได้ {{ok}} ส่งไม่ได้ {{failed}} — ดูแถวสีแดง"
  },
  "draft": {
    "title": "สร้างออเดอร์ (แชท/LINE)",
    "intro": "สำหรับลูกค้าที่ซื้อทางแชท การ์ดจะถูกจองไว้ 3 วัน ลูกค้าได้ลิงก์ติดตามและเลขบัญชีทางอีเมล",
    "customer": "ลูกค้า",
    "email": "อีเมลลูกค้า",
    "language": "ภาษาของลูกค้า",
    "language_hint": "อีเมลจะส่งเป็นภาษานี้",
    "locales": {
      "en": "English",
      "ja": "日本語",
      "th": "ไทย",
      "zh_Hant": "繁體中文",
      "zh_Hans": "简体中文"
    },
    "items": "สินค้า",
    "scan": "สแกนหรือค้นหาสินค้า",
    "scan_hint": "รหัสสินค้า บาร์โค้ด เลขใบรับรอง หรือชื่อ",
    "no_items": "ยังไม่มีสินค้า",
    "remove": "เอา {{title}} ออก",
    "price_hint": "ราคา ค่าส่ง และภาษี ระบบของร้านคิดให้ตอนสร้างออเดอร์",
    "delivery": "วิธีรับของ",
    "payment": "การชำระ",
    "payment_ship": "ชำระ: โอนเงินผ่านธนาคาร (銀行振込) ภายใน 3 วัน",
    "address": {
      "country": "ประเทศ",
      "country_hint": "2 ตัวอักษร เช่น JP, US",
      "postal_code": "รหัสไปรษณีย์",
      "region": "จังหวัด/รัฐ",
      "city": "เมือง",
      "address1": "บ้านเลขที่ ถนน",
      "address2": "อาคาร ห้อง",
      "name": "ชื่อ",
      "phone": "โทรศัพท์",
      "name_kana": "ชื่อ (คานะ)",
      "company": "บริษัท"
    },
    "note": "โน้ต (ไม่บังคับ)",
    "note_hint": "แสดงในออเดอร์สำหรับทีม",
    "create": "สร้างออเดอร์",
    "creating": "กำลังสร้าง…",
    "problem": {
      "email": "พิมพ์อีเมลลูกค้า",
      "lines": "เพิ่มสินค้าอย่างน้อย 1 ชิ้น",
      "address": "พิมพ์ประเทศ ที่อยู่ และชื่อ"
    },
    "done": "สร้าง {{number}} แล้ว",
    "done_hint": "ลูกค้าได้อีเมลลิงก์ติดตามและเลขบัญชี",
    "done_title": "สร้าง {{number}} แล้ว",
    "done_body": "การ์ดถูกจองไว้ให้ลูกค้า วางลิงก์ในแชทได้",
    "tracking_link": "หน้าออเดอร์ของลูกค้า",
    "tracking_once": "ลิงก์นี้แสดงแค่ตอนนี้ ลูกค้ามีในอีเมลด้วย",
    "copy": "คัดลอกลิงก์",
    "copied": "คัดลอกแล้ว",
    "open": "เปิดออเดอร์",
    "another": "สร้างออเดอร์อีก"
  },
  "conflicts": {
    "intro": "ปัญหาที่ต้องดู: การ์ดขายซ้ำ ออเดอร์ที่รอตรวจ จำนวนสต็อกที่ไม่ตรงกับประวัติ",
    "tabs": "ชนิดของปัญหา",
    "tab": {
      "sold-twice": "ขายซ้ำ",
      "to-check": "ออเดอร์ที่ต้องตรวจ",
      "stock-differences": "สต็อกไม่ตรง"
    },
    "show_closed": "แสดงที่ตัดสินแล้วด้วย",
    "load_failed": "โหลดปัญหาไม่ได้",
    "none": "ไม่มีการ์ดที่ขายซ้ำ",
    "none_body": "ถ้าเว็บกับหน้าร้านขายการ์ดใบเดียวกันพร้อมกัน จะขึ้นที่นี่",
    "none_to_check": "ไม่มีออเดอร์ที่รอตรวจ",
    "to_check_intro": "ออเดอร์ที่มีปัญหาหรือรอผู้จัดการ (รวมถึงการขายหน้าร้านตอนเน็ตหลุด)",
    "stock_intro": "ระบบตรวจทุกคืนว่าจำนวนสต็อกตรงกับประวัติ",
    "open_movements": "เปิดประวัติสต็อก",
    "summary": "{{winner}} กับ {{loser}} ได้การ์ดใบเดียวกัน",
    "status": {
      "open": "ต้องตัดสิน",
      "resolved": "ตัดสินแล้ว",
      "dismissed": "ปิดแล้ว"
    },
    "back": "ปัญหาทั้งหมด",
    "title": "การ์ดใบเดียวกันถูกขายสองครั้ง",
    "what": {
      "order_paid": "{{winner}} จ่ายก่อน {{loser}} ก็จ่ายแล้ว แต่การ์ดไม่อยู่แล้ว",
      "offline_commit": "{{loser}} ขายที่เครื่องแคชเชียร์ตอนเน็ตหลุด แต่การ์ดเป็นของ {{winner}} ไปแล้ว",
      "external_paid": "{{loser}} มาจากร้านอื่นหลังจาก {{winner}} ได้การ์ดไปแล้ว"
    },
    "side": {
      "winner": "ได้การ์ด",
      "loser": "ไม่ได้การ์ด"
    },
    "open_order": "เปิดออเดอร์",
    "timeline": "เกิดอะไรขึ้น",
    "event": {
      "winner": "{{label}}",
      "loser": "{{label}}",
      "detected": "ระบบพบปัญหา",
      "resolved": "ตัดสินแล้ว"
    },
    "policy": {
      "external_paid_wins": "กฎที่ใช้: การขายที่จ่ายเงินแล้วชนะการจองที่ยังไม่จ่าย",
      "first_paid_wins": "กฎที่ใช้: ใครจ่ายก่อนได้การ์ด"
    },
    "fix": "วิธีแก้",
    "decision": {
      "keep_winner": "ยกเลิกออเดอร์อีกฝั่ง + แจ้งลูกค้า",
      "dismiss": "ทำเครื่องหมายว่าตรวจแล้ว",
      "swap_to_loser": "ให้การ์ดกับลูกค้าอีกคน",
      "both_cancelled": "ยกเลิกทั้งสอง"
    },
    "note": "ตัดสินอย่างไรและทำไม",
    "note_hint": "เก็บในประวัติ",
    "note_required": "เขียนสั้นๆ",
    "done": {
      "keep_winner": "ตัดสินแล้ว — ยกเลิกออเดอร์อีกฝั่งและแจ้งลูกค้า",
      "dismiss": "ทำเครื่องหมายว่าตรวจแล้ว",
      "swap_to_loser": "การ์ดไปที่ลูกค้าอีกคน",
      "both_cancelled": "ยกเลิกทั้งสองแล้ว"
    },
    "cancel_other": "เปิดออเดอร์อีกฝั่งเพื่อยกเลิก"
  },
  "refund": {
    "title": "คืนเงิน · {{number}}",
    "description": "ที่นี่แค่บันทึก — ร้านโอน/จ่ายเงินเอง (ธนาคาร เงินสด) ถ้าของถูกส่งกลับ ให้ใช้ \"รับคืนสินค้า\"",
    "confirm": "บันทึกคืน ¥{{amount}}",
    "confirm_plain": "บันทึกการคืนเงิน",
    "nothing": "ออเดอร์นี้ยังไม่ได้รับเงิน จึงคืนเงินไม่ได้",
    "which_payment": "คืนจากการจ่ายเงินไหน?",
    "left": "คืนได้สูงสุด",
    "already": "คืนไปแล้ว",
    "amount": "ยอดที่คืน",
    "why": "เหตุผล",
    "reasons": {
      "price_adjustment": "แก้ราคา",
      "goodwill": "ขอโทษลูกค้า",
      "overpayment": "ลูกค้าจ่ายเกิน",
      "other": "อื่นๆ",
      "order_cancelled": "ยกเลิกออเดอร์",
      "return": "ของถูกส่งคืน",
      "tax_free_refund": "คืนภาษี 免税"
    },
    "note": "เขียนสั้นๆ (เก็บในประวัติ)",
    "how": "คืนเงินอย่างไร?",
    "methods": {
      "original": "วิธีเดียวกับที่จ่าย",
      "bank_transfer": "โอนเข้าบัญชีลูกค้า",
      "cash": "เงินสดที่เคาน์เตอร์",
      "store_credit": "เครดิตร้าน (ใช้ได้ 6 เดือน)",
      "edc_manual": "ยกเลิกที่เครื่องรูดบัตร"
    },
    "consequence": {
      "original": "คืนเงินด้วยวิธีเดียวกับที่ลูกค้าจ่าย แล้วกด \"บันทึก\"",
      "bank_transfer": "โอนเงินที่ธนาคาร แล้วกด \"โอนเงินแล้ว\" พร้อมเลขจากธนาคาร",
      "cash": "ให้เงินสดลูกค้า แล้วกด \"บันทึก\"",
      "store_credit": "เครดิตเข้าบัญชีลูกค้าทันที",
      "edc_manual": "ยกเลิกรายการที่เครื่องรูดบัตร แล้วใส่เลขสลิป"
    },
    "blocker": {
      "amount_invalid": "ใส่ยอดเป็นเยนเต็มจำนวน",
      "amount_too_high": "มากกว่ายอดที่คืนได้ของการจ่ายนี้",
      "note_required": "เลือก \"อื่นๆ\" ต้องเขียนสั้นๆ",
      "account_incomplete": "กรอกบัญชีลูกค้าให้ครบทุกช่อง (เลขบัญชี 7 หลัก) หรือเว้นว่างทั้งหมด"
    },
    "done": "บันทึกการคืนเงินของ {{number}} แล้ว",
    "done_approval": "ผู้จัดการต้องอนุมัติก่อนโอนเงิน",
    "destination": {
      "title": "บัญชีธนาคารของลูกค้า",
      "hint": "ถ้ายังไม่มี เว้นว่างไว้ — การคืนเงินจะรอบัญชี",
      "bankName": "ธนาคาร",
      "branchName": "สาขา",
      "accountType": "ประเภทบัญชี",
      "accountNumber": "เลขบัญชี (7 หลัก)",
      "accountName": "ชื่อบัญชี (คานะ)",
      "types": {
        "futsu": "普通 (ออมทรัพย์)",
        "toza": "当座 (กระแสรายวัน)"
      }
    }
  },
  "refunds": {
    "title": "เงินที่ต้องคืน",
    "open_other": "ต้องทำ {{count}} รายการ",
    "phase1": "การคืนเงินผ่านบัตรจะมีภายหลัง ตอนนี้ร้านโอน/จ่ายเงินเองแล้วบันทึกที่นี่",
    "step": {
      "waiting_approval": "รออนุมัติ",
      "hand_cash": "ให้เงินสด",
      "enter_terminal_reference": "ยกเลิกที่เครื่อง",
      "waiting_destination": "รอบัญชี",
      "transfer_money": "โอนเงิน",
      "done": "คืนเงินแล้ว",
      "rejected": "ไม่อนุมัติ",
      "failed": "ไม่สำเร็จ"
    },
    "next": {
      "waiting_approval": "ต้องให้ผู้จัดการอีกคนอนุมัติการคืนเงินนี้",
      "hand_cash": "ให้เงินสดลูกค้า แล้วบันทึก",
      "enter_terminal_reference": "ยกเลิกที่เครื่องรูดบัตร แล้วใส่เลขสลิป",
      "waiting_destination": "รอบัญชีธนาคารของลูกค้า — ลูกค้ากรอกเองในหน้าออเดอร์ (ยังใช้ไม่ได้: ถ้ารอไม่ได้ให้คืนเป็นเงินสดหรือเครดิตร้านแทน)",
      "transfer_money": "โอนเงินที่ธนาคาร แล้วบันทึกเลขจากธนาคาร",
      "done": "เสร็จ — ลูกค้าได้เงินคืนแล้ว",
      "rejected": "การคืนเงินนี้ไม่ได้รับอนุมัติ",
      "failed": "การคืนเงินนี้ไม่สำเร็จ — ดูหมายเหตุหรือลองใหม่"
    },
    "approve": "อนุมัติ",
    "reject": "ไม่อนุมัติ",
    "done_approve": "อนุมัติการคืนเงินแล้ว",
    "done_reject": "ไม่อนุมัติการคืนเงินแล้ว",
    "approve_title": "อนุมัติการคืนเงินนี้?",
    "approve_consequence": "จากนั้นโอนเงินให้ลูกค้าได้",
    "reject_title": "ไม่อนุมัติการคืนเงินนี้?",
    "reject_consequence": "จะไม่มีการคืนเงิน เหตุผลเก็บไว้ในประวัติ",
    "record": {
      "bank": "โอนเงินแล้ว",
      "other": "บันทึก"
    },
    "record_title": "บันทึกการคืนเงิน",
    "record_description": {
      "bank": "ใส่เลขอ้างอิงการโอนจากธนาคาร",
      "other": "ใส่เลขใบเสร็จหรือเลขสลิป"
    },
    "record_save": "บันทึก",
    "recorded": "บันทึกแล้ว — ลูกค้าได้เงินคืน",
    "recorded_hint": "ลูกค้าได้อีเมลและเอกสารอัตโนมัติ",
    "reference_required": "ใส่เลขจากธนาคารหรือเลขสลิป",
    "reference": {
      "bank": "เลขอ้างอิงการโอน",
      "other": "เลขใบเสร็จ / สลิป"
    },
    "reference_hint": "ไว้ค้นหาภายหลัง",
    "when": "วันเวลา",
    "amount": "ยอด",
    "show_account": "แสดงบัญชี",
    "show_account_hint": "ทุกครั้งที่ดูจะถูกบันทึก",
    "no_account": "ยังไม่รู้บัญชีลูกค้า — ถามลูกค้า",
    "ref": "เลขที่",
    "tax_part": "รวมภาษีบริโภค"
  },
  "returns": {
    "title": "การคืนสินค้า",
    "intro": "ของที่ลูกค้าส่งคืน: อนุมัติ → รับพัสดุ → ตรวจทีละชิ้น → คืนเงิน",
    "start": "รับคืนสินค้า",
    "none": "ยังไม่มีการคืนสินค้า",
    "created": "เปิดการคืนสินค้าของ {{number}} แล้ว",
    "created_hint": "ถ้าตกลง ให้กดอนุมัติ — ลูกค้าจะได้อีเมลวิธีส่งคืน",
    "start_title": "รับคืนสินค้า · {{number}}",
    "start_description": "เฉพาะของที่ส่งไปแล้วและยังไม่ได้คืนเงิน",
    "start_confirm": "เปิดการคืนสินค้า",
    "none_chosen": "เลือกอย่างน้อย 1 ชิ้น",
    "what": "ของชิ้นไหนที่ส่งคืน?",
    "why": "เหตุผล",
    "reasons": {
      "damaged_in_transit": "เสียหายระหว่างขนส่ง",
      "not_as_described": "ไม่ตรงตามคำอธิบาย",
      "wrong_item": "ส่งของผิด",
      "sealed_unopened_7d": "ยังไม่แกะซีล (ภายใน 7 วัน)",
      "legal_8day": "ภายใน 8 วัน (ตามกฎหมาย)",
      "other": "อื่นๆ"
    },
    "description": "ลูกค้าบอกว่า",
    "override": "เหตุผลที่ยังรับคืน",
    "override_hint": "นอกกฎการคืนสินค้า — ผู้จัดการรับได้ถ้าเขียนเหตุผล",
    "consigned_note": "ของฝากขาย: ยอดที่จะจ่ายผู้ฝากสำหรับชิ้นนี้จะถูกย้อนกลับ",
    "approve_title": "อนุมัติการคืนสินค้า · {{number}}",
    "approve_description": "ลูกค้าจะได้อีเมลวิธีส่งคืน",
    "approve": "อนุมัติ",
    "approved": "อนุมัติการคืนสินค้าแล้ว",
    "approved_hint": "ลูกค้าได้วิธีส่งคืนแล้ว",
    "postage": "ใครจ่ายค่าส่งคืน?",
    "paid_by": {
      "shop": "ร้านจ่าย",
      "customer": "ลูกค้าจ่าย"
    },
    "instructions": "คำแนะนำสำหรับลูกค้า",
    "instructions_placeholder": "เช่น ส่งด้วย Click Post มาที่ที่อยู่ร้าน",
    "receive": "返品受領 — ได้รับพัสดุคืนแล้ว",
    "receive_title": "ได้รับพัสดุคืน · {{number}}",
    "receive_description": "ตรวจทีละชิ้น: กลับมาขาย หรือเสียหาย แล้วระบบคำนวณยอดคืน",
    "receive_confirm": "บันทึกและคำนวณยอดคืน",
    "received": "รับของคืนแล้ว",
    "received_refund": "ต้องคืน ¥{{amount}} — ดูช่อง \"เงินที่ต้องคืน\"",
    "received_hint": "กำลังคำนวณยอดคืน",
    "damage_note_required": "ชิ้นที่เสียหาย ต้องเขียนว่าเสียตรงไหน",
    "arrived": "ได้รับกี่ชิ้น",
    "arrived_n_other": "ได้รับ {{count}} ชิ้น",
    "state": "สภาพ",
    "disposition": {
      "restock": "กลับมาขาย",
      "damage": "เสียหาย"
    },
    "condition_note": "เสียตรงไหน / หมายเหตุ",
    "location": "เก็บที่",
    "location_hint": "วางกลับที่ชั้นไหน",
    "location_default": "ที่เดิม",
    "refund_amount": "ยอดคืน",
    "refund_tax": "ภาษีบริโภค",
    "henkan_yes": "การคืนเงินนี้จะออก 返還インボイス (ใบลดหนี้)",
    "henkan_no": "การคืนเงินนี้ไม่ต้องออก 返還インボイス",
    "refund_status": {
      "pending": "ยังไม่ได้ขอคืนเงิน — กด \"ขอคืนเงินอีกครั้ง\"",
      "failed": "ขอคืนเงินไม่สำเร็จ — ลองอีกครั้ง",
      "requested": "บันทึกแล้ว — โอนเงินแล้วบันทึก",
      "approval_required": "รอผู้จัดการอนุมัติ",
      "refunded": "คืนเงินแล้ว"
    },
    "status": {
      "requested": "ขอคืน",
      "approved": "อนุมัติแล้ว — รอพัสดุ",
      "rejected": "ไม่รับคืน",
      "received": "ได้รับพัสดุคืน",
      "closed": "เสร็จ"
    },
    "reject_reason": "เหตุผล:",
    "ask_refund": "ขอคืนเงินอีกครั้ง",
    "refund_asked": "ขอคืนเงินแล้ว",
    "reject": "ไม่รับคืน",
    "rejected": "ไม่รับคืนสินค้าแล้ว",
    "reject_title": "ไม่รับคืนสินค้านี้?",
    "reject_consequence": "ลูกค้าจะได้อีเมลพร้อมเหตุผลของคุณ",
    "columns": {
      "order": "ออเดอร์",
      "status": "สถานะ",
      "reason": "เหตุผล",
      "items": "สินค้า",
      "refund": "ยอดคืน",
      "requested": "ขอเมื่อ"
    }
  },
  "edit": {
    "title": "แก้ที่อยู่ · {{number}}",
    "description": "แก้ได้ก่อนส่งของ",
    "description_paid": "จ่ายแล้ว: เปลี่ยนประเทศอาจทำให้ภาษีและค่าส่งเปลี่ยน — ระบบคำนวณใหม่และแจ้งให้ทราบ",
    "save": "บันทึกการแก้ไข",
    "saved": "บันทึกแล้ว",
    "saved_hint": "เอกสารของลูกค้าใช้ข้อมูลใหม่",
    "stale": "มีคนเพิ่งแก้ออเดอร์นี้ ปิดแล้วเปิดใหม่",
    "fill_required": "กรอกช่องที่จำเป็น",
    "required": "จำเป็น",
    "postal_hint": "ใส่ 7 หลักแล้วที่อยู่จะเติมให้",
    "postal_found": "เติมที่อยู่แล้ว — เพิ่มบ้านเลขที่",
    "postal_unknown": "ไม่พบรหัสไปรษณีย์นี้ — พิมพ์ที่อยู่เอง",
    "country_warning": "เปลี่ยนประเทศหลังจ่ายเงิน ภาษี (ญี่ปุ่น 10% ↔ ส่งออก 0%) และค่าส่งจะเปลี่ยน คุณจะเห็นผลก่อนทำอย่างอื่น",
    "undo_address": "ใช้ที่อยู่เดิม",
    "close": "ตกลง",
    "outcome_title": "สิ่งที่เปลี่ยน",
    "tax_changed": "ภาษี: {{before}} → {{after}}",
    "total_changed": "ยอดรวม:",
    "adjustment": {
      "balance_due": "ลูกค้าต้องจ่ายเพิ่ม:",
      "refund_due": "ต้องคืนเงินลูกค้า:"
    },
    "notices": {
      "shipping_rate_changed": "ค่าส่งเปลี่ยนเป็นวิธีที่ถูกที่สุดสำหรับที่อยู่ใหม่",
      "other": "ระบบเปลี่ยนอย่างอื่นด้วย — ดูประวัติออเดอร์"
    },
    "payment_updated": "อัปเดตยอดที่ลูกค้าต้องโอนแล้ว",
    "no_money_change": "ภาษีและยอดรวมเท่าเดิม"
  },
  "documents": {
    "title": "เอกสาร",
    "page_title": "เอกสาร · {{number}}",
    "back": "กลับไป {{number}}",
    "create": "สร้างเอกสาร",
    "none": "ยังไม่มีเอกสาร",
    "making": "กำลังสร้างเอกสาร — เสร็จแล้วจะเปิดเอง",
    "media_down": "ระบบเอกสารยังไม่ตอบ ลองใหม่อีกสักครู่",
    "failed": "สร้างเอกสารไม่สำเร็จ ลองอีกครั้ง",
    "same_file": "เอกสารนี้เคยสร้างแล้ว",
    "same_file_hint": "เปิดไฟล์เดิม — ไม่ได้สร้างใหม่",
    "t_number": "เลขทะเบียนบนใบเสร็จ:",
    "t_number_missing": "ยังไม่ตั้ง — ตั้งค่า › ภาษี",
    "t_number_placeholder": "เลขทดสอบ — แก้ที่ ตั้งค่า › ภาษี",
    "types": {
      "ryoshusho": "領収書 (ใบเสร็จ)",
      "kani_invoice": "適格簡易請求書 (ใบกำกับอย่างย่อ)",
      "tekikaku_invoice": "適格請求書 (ใบกำกับมีชื่อผู้ซื้อ)",
      "henkan_invoice": "返還インボイス (ใบลดหนี้)",
      "commercial_invoice": "Commercial invoice (ส่งออก)",
      "packing_slip": "納品書 (ใบส่งของ)",
      "customs_cn22": "ใบศุลกากร CN22",
      "customs_cn23": "ใบศุลกากร CN23",
      "customs_declaration": "ใบศุลกากร (CN22/CN23)",
      "refund_note": "หนังสือแจ้งคืนเงิน",
      "tax_free_slip": "บันทึก 免税",
      "taxfree_explanation": "คำอธิบาย 免税",
      "refund_evidence": "หลักฐานการคืนเงิน"
    },
    "type_help": {
      "ryoshusho": "ใบเสร็จปกติ",
      "kani_invoice": "ใบเสร็จมีเลขทะเบียนและภาษี",
      "tekikaku_invoice": "สำหรับบริษัท — ต้องมีชื่อผู้ซื้อ",
      "packing_slip": "ใส่ในกล่องพัสดุ",
      "commercial_invoice": "สำหรับศุลกากรต่างประเทศ",
      "customs_declaration": "ข้อมูลสติกเกอร์ศุลกากร"
    },
    "unavailable": {
      "not_paid": "สร้างได้หลังจ่ายเงิน",
      "not_export": "เฉพาะพัสดุไปต่างประเทศ"
    },
    "status": {
      "requested": "กำลังสร้าง",
      "ready": "พร้อมแล้ว",
      "failed": "สร้างไม่สำเร็จ",
      "superseded": "มีฉบับใหม่แทนแล้ว"
    },
    "to": "ถึง: {{name}}",
    "hash": "ลายนิ้วมือไฟล์",
    "version": "ฉบับที่ {{n}}",
    "open": "เปิด",
    "download": "ดาวน์โหลด",
    "resend": "ส่งอีเมลอีกครั้ง",
    "resent": "ส่งอีเมลอีกครั้งแล้ว",
    "create_title": "สร้างเอกสาร · {{number}}",
    "create_description": "ระบบสร้าง PDF พร้อมข้อมูลร้านและเก็บไว้ 7 ปี",
    "create_confirm": "สร้างและเปิด",
    "which": "เอกสารไหน?",
    "recipient": "ชื่อผู้ซื้อ (宛名)",
    "recipient_hint": "ชื่อบริษัทหรือบุคคลตามที่ต้องการให้แสดง",
    "problem": {
      "recipient_required": "適格請求書 ต้องมีชื่อผู้ซื้อ (宛名)"
    },
    "with_prices": "แสดงราคาในใบส่งของ",
    "language": "ภาษาของเอกสาร",
    "language_hint": "เลือกภาษาของลูกค้าไว้ให้แล้ว",
    "preview": "เอกสาร",
    "n_of": "{{n}} จาก {{total}}",
    "previous": "ก่อนหน้า",
    "next": "ถัดไป",
    "print": "พิมพ์",
    "close": "ปิด",
    "loading": "กำลังเปิดเอกสาร…",
    "bulk_title": {
      "packing_slip_other": "ใบส่งของ {{count}} ออเดอร์",
      "commercial_invoice_other": "Commercial invoice {{count}} ออเดอร์"
    },
    "bulk_description": "สร้างเอกสารของแต่ละออเดอร์ (ใช้ไฟล์เดิมถ้ามี) แล้วพิมพ์ทีละใบต่อกัน",
    "bulk_print_other": "พิมพ์ {{count}} ใบ",
    "bulk_progress": "เอกสารที่สร้างแล้ว",
    "bulk_state": {
      "waiting": "รอ",
      "making": "กำลังสร้าง",
      "ready": "พร้อมแล้ว",
      "skipped": "ไม่ต้องใช้",
      "failed": "สร้างไม่สำเร็จ"
    },
    "bulk_open": "พิมพ์ทีละใบต่อกัน"
  }
}
